import { RouterProvider } from "react-router-dom";
import { router } from "./routes";
import { AppProviders } from "./providers/AppProviders";

/**
 * Root App Component
 * Wraps the entire application with providers and routing
 */
function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}

export default App;
